export const state = {
  fanbaseGrowthTable: {
    isLoading: false,
    hasError: false,
    data: [],
  },
  fanbaseEvolution: {
    isLoading: false,
    hasError: false,
    data: [],
    periodSelected: '',
  },
  totalPublication: {
    isLoading: false,
    hasError: false,
    data: {
      categories: [],
      series: [],
    },
  },
  publicationByMediaType: {
    isLoading: false,
    hasError: false,
    data: {
      categories: [],
      series: [],
    },
  },
  topPublicationByChannel: {
    isLoading: false,
    hasError: false,
    data: [],
  },
  interactionsOverTime: {
    isLoading: false,
    hasError: false,
    data: [],
    periodSelected: '',
  },
  interactionsAndEngagementRate: {
    isLoading: false,
    hasError: false,
    data: {
      categories: [],
      series: [],
    },
  },
  interactionsBySocialNetworkAndMediaType: {
    isLoading: false,
    hasError: false,
    data: {
      categories: [],
      series: [],
    },
  },
  averageInteractionsByPublication: {
    isLoading: false,
    hasError: false,
    data: {
      categories: [],
      series: [],
      metadata: [],
    },
  },
  engagementOverTime: {
    isLoading: false,
    hasError: false,
    data: [],
    periodSelected: '',
  },
  engagementMatrix: {
    isLoading: false,
    hasError: {
      default: false,
      pidLimit: false,
    },
    data: {
      series: [],
      metadata: {
        xAxis: {
          maximum: 0,
          minimum: 0,
          middle: 0,
        },
        yAxis: {
          maximum: 0,
          minimum: 0,
          middle: 0,
        },
      },
    },
  },
  distributionOfInteractions: {
    isLoading: false,
    hasError: false,
    data: {
      categories: [],
      series: [],
    },
  },
  sentimentsInTheComments: {
    isLoading: false,
    hasError: false,
    data: {
      categories: [],
      series: [],
    },
  },
  termsMentioned: {
    isLoading: false,
    hasError: false,
    data: [],
  },
  publicationsOverTimeWithDistribution: {
    isLoading: false,
    hasError: false,
    data: {
      categories: [],
      series: [],
    },
    periodSelected: '',
    groupSelected: '',
  },
  sentimentsInTheCommentsOverTime: {
    isLoading: false,
    hasError: false,
    data: [],
    periodSelected: '',
    groupSelected: '',
  },
};
